import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import { TextTitle } from "../../../components/atoms/text/titles";
import { FetchFromBackoffice, PostBackoffice } from "../../../utils/request";
import { AuthenticatedUser, CommentCommand, CommentsResponse, CommentViewItem, DeleteCommentCommand } from "../types";
import { CommentTextArea } from "./commentTextArea";
import { Comment } from "./comment";
import { Box } from "@mui/material";
import './comments.css'

export const Comments = ({ serialId }: { serialId: string | undefined }) => {

  const user = useSelector((state: AuthenticatedUser) => state.authenticated_user);
  const [comments, setComments] = useState<CommentViewItem[]>([]);
  const [attachments, setAttachments] = useState<string[]>([])

  const onUploadFile = (blobId: string) => {
    setAttachments((prev) => [...prev, blobId])
  }

  const onRemoveFile = (blobId: string) => {
    setAttachments(prev => prev.filter(id => id !== blobId))
  }

  const saveComment = async (inputText: string) => {
    if (!inputText.trim())
      return

    const newComment: CommentCommand = {
      id: serialId!,
      commentId: uuidv4(),
      text: inputText,
      timestamp: new Date().toISOString(),
      userId: user.sub,
      userName: formatNickname(user.nickname),
      attachments: attachments
    }

    try {
      setComments(current => [newComment, ...current])
      setAttachments([])
      await PostBackoffice("/cmd/machine/comment/add", newComment)
    } catch (error) {
      console.error("Failed to save comment:", error)
      setComments((current) => [...current.filter((c) => c.commentId !== newComment.commentId)])
    }
  }

  const deleteComment = async (commentId: string) => {

    const commentToDelete = comments.find(comment => comment.commentId === commentId);

    if (!commentToDelete)
      return;

    const data: DeleteCommentCommand = {
      id: serialId!,
      commentId: commentId,
      userId: user.sub
    }
    try {
      setComments(current => {
        const removedComment = current.filter(comment => comment.commentId !== commentId);
        return removedComment;
      });
      await PostBackoffice<DeleteCommentCommand>('/cmd/machine/comment/delete', data);
    } catch (error) {
      setComments(current => [commentToDelete, ...current])
      console.error('Could not delete comment:', error);

    }
  }

  const fetchComments = async () => {
    if (!serialId)
      return
    try {
      const res = await FetchFromBackoffice<CommentsResponse>(`/machines/${serialId}/comments?count=100`)
      setComments(res.items)
    } catch (error) {
      console.error("Failed to fetch comments:", error)
    }
  }

  useEffect(() => {
    fetchComments()

  }, [serialId])

  const formatNickname = (nickname: string) => {
    return nickname
      .split(".")
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");
  };


  return (
    <Box style={{ width: "100%" }}>
      <Box style={{
        margin: "0 10px",
      }}>
        <TextTitle title={"Comments"} />
      </Box>
      <Box style={{
        margin: "0 10px",
        padding: "20px 40px 20px ",
        boxShadow: 'rgb(113 122 131 / 11%) 0px 7px 30px 0px',
        marginBottom: "12px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }}>
        <CommentTextArea onUploadFile={onUploadFile} onRemoveFile={onRemoveFile} onSave={saveComment}/>

      </Box>
      <Box style={{ width: "100%" }}>

        <Box className="comments-scroll-area" style={{
          maxHeight: 470,
          padding: "10px",
        }}>
          {comments.map((comment => (
            <Comment userName={formatNickname(comment.userName)} userId={user.sub} loggedInUser={comment.userId} timeStamp={comment.timestamp} commentId={comment.commentId} text={comment.text} onDelete={deleteComment} attachments={comment.attachments}/>

          )))}
        </Box>
      </Box>
    </Box >
  )
}

